import "@mantine/dropzone/styles.css";
import { Dropzone as MantineDropzone, DropzoneProps } from "@mantine/dropzone";
import Button from "@/components/Button";
import Text from "../Text";
import classes from "./index.module.css";
import { Upload } from "../Icons";
import { ReactNode } from "react";

interface Props extends DropzoneProps {
  label: ReactNode;
  buttonLabel: string;
  hasError?: boolean;
}

const DropzoneButton = ({ label, className, hasError }: { label: string; className?: string; hasError?: boolean }) => (
  <Button
    variant="outline"
    className={className}
    leftSection={<Upload fontSize="1.75rem" />}
    style={hasError ? { background: "transparent" } : undefined}>
    <Text variant="reading_bold">{label}</Text>
  </Button>
);

const Dropzone = ({ label, buttonLabel, hasError, ...rest }: Props) => {
  return (
    <MantineDropzone
      {...rest}
      classNames={classes}
      data-error={hasError}
      tabIndex={-1}
      inputProps={{
        "aria-label": buttonLabel,
      }}>
      <div>
        <Text variant="reading_medium" color="neutral.9">
          {label}
        </Text>
      </div>
      <MantineDropzone.Accept>
        <DropzoneButton label={buttonLabel} className={classes.button} hasError={hasError} />
      </MantineDropzone.Accept>
      <MantineDropzone.Idle>
        <DropzoneButton label={buttonLabel} className={classes.button} hasError={hasError} />
      </MantineDropzone.Idle>
      <MantineDropzone.Reject>
        <DropzoneButton label={buttonLabel} className={classes.buttonReject} hasError={hasError} />
      </MantineDropzone.Reject>
    </MantineDropzone>
  );
};

export default Dropzone;
